import { useUser } from '../../data/UserContext'
import { grantAccess } from '../../utils/grantAccess'

export const Authorize = ({
  children,
  roles,
  canUseInternshipPermission,
  isInternshipDirector,
}) => {
  const { user } = useUser()

  if (grantAccess({
    user,
    roles,
    canUseInternshipPermission,
    isInternshipDirector,
  })) {
    return children
  }

  return null
}
